import axios from "axios";
import store from "@/store";
import { apiPrefix } from "./config";
import { authInterceptor } from "./auth-interceptor";

const authorization = store.getters['settings/auth'].cookie ? {Authorization: store.getters['settings/auth'].cookie} : undefined;

const DEFAULT_HEADERS = {
  "Accept": "application/json",
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Credentials": true,
  ...authorization
};


export const api = axios.create({
  baseURL: apiPrefix,
  headers: { ...DEFAULT_HEADERS },
  withCredentials: true,
});

export const apiDefault = axios.create({
  headers: { ...DEFAULT_HEADERS },
  withCredentials: true,
});

authInterceptor(api);
api.interceptors.response.use(response => response.data);

authInterceptor(apiDefault);
apiDefault.interceptors.response.use(response => response.data);
